import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { IFaqSectionDto } from "../interface/dto/faq.dto";
import { fetchFaqSections } from "../service/faq.api";

const {
    actions: faqActions,
    reducer: faqReducer,
    epic: faqEpic,
} = createIGSERedux<Array<IFaqSectionDto>>({
    actionNames: {
        init: "FAQ_PAGE_INIT",
        get: "FAQ_LOAD_SECTIONS_GET",
        success: "FAQ_LOAD_SECTIONS_SUCCESS",
        error: "FAQ_LOAD_SECTIONS_ERROR",
    },
    fetcher: () => fetchFaqSections(selectAuthTokens()),
    selector: (state: IRootState) => state.faq,
});

export { faqActions, faqReducer, faqEpic };
